import React from 'react';
import Icon from '../../../components/AppIcon';



const PTOFilterPanel = ({ filters, onChange, departments }) => {
  const ptoTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'Vacation', label: 'Vacation' },
    { value: 'Sick', label: 'Sick' },
    { value: 'Personal', label: 'Personal' },
    { value: 'Bereavement', label: 'Bereavement' },
    { value: 'Other', label: 'Other' },
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Denied', label: 'Denied' },
    { value: 'Cancelled', label: 'Cancelled' },
  ];

  const deptOptions = [
    { value: 'all', label: 'All Departments' },
    ...departments?.map((d) => ({ value: d, label: d })),
  ];

  return (
    <div className="bg-card rounded-xl p-4 elevation-sm space-y-4">
      <div className="flex items-center gap-2 mb-2">
        <Icon name="SlidersHorizontal" size={16} className="text-muted-foreground" />
        <span className="text-sm font-body font-semibold text-foreground">Filters</span>
      </div>
      <div>
        <label className="text-xs font-caption text-muted-foreground mb-1 block">Search Employee</label>
        <div className="relative">
          <Icon name="Search" size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Name or ID..."
            value={filters?.search ?? ''}
            onChange={(e) => onChange({ ...filters, search: e?.target?.value })}
            className="w-full pl-8 pr-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 text-foreground placeholder:text-muted-foreground"
          />
        </div>
      </div>
      <div>
        <label className="text-xs font-caption text-muted-foreground mb-1 block">PTO Type</label>
        <select
          value={filters?.ptoType ?? 'all'}
          onChange={(e) => onChange({ ...filters, ptoType: e?.target?.value })}
          className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 text-foreground"
        >
          {ptoTypeOptions?.map((o) => (
            <option key={o?.value} value={o?.value}>{o?.label}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="text-xs font-caption text-muted-foreground mb-1 block">Status</label>
        <select
          value={filters?.status ?? 'all'}
          onChange={(e) => onChange({ ...filters, status: e?.target?.value })}
          className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 text-foreground"
        >
          {statusOptions?.map((o) => (
            <option key={o?.value} value={o?.value}>{o?.label}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="text-xs font-caption text-muted-foreground mb-1 block">Department</label>
        <select
          value={filters?.department ?? 'all'}
          onChange={(e) => onChange({ ...filters, department: e?.target?.value })}
          className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 text-foreground"
        >
          {deptOptions?.map((o) => (
            <option key={o?.value} value={o?.value}>{o?.label}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="text-xs font-caption text-muted-foreground mb-1 block">Start Date From</label>
        <input
          type="date"
          value={filters?.dateFrom ?? ''}
          onChange={(e) => onChange({ ...filters, dateFrom: e?.target?.value })}
          className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 text-foreground"
        />
      </div>
      <div>
        <label className="text-xs font-caption text-muted-foreground mb-1 block">Start Date To</label>
        <input
          type="date"
          value={filters?.dateTo ?? ''}
          onChange={(e) => onChange({ ...filters, dateTo: e?.target?.value })}
          className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 text-foreground"
        />
      </div>
      <button
        onClick={() => onChange({ search: '', ptoType: 'all', status: 'all', department: 'all', dateFrom: '', dateTo: '' })}
        className="w-full py-2 text-xs font-caption text-muted-foreground hover:text-foreground border border-border rounded-lg hover:bg-muted transition-colors"
      >
        Clear Filters
      </button>
    </div>
  );
};

export default PTOFilterPanel;
